var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRankingSelecionado({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 41,
    rx: 8,
    fill: "#8E58BF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 23.16V24.786C18.4962 25.1286 18.4045 25.4645 18.2336 25.7615C18.0627 26.0585 17.8183 26.3066 17.524 26.482C16.8991 26.9448 16.3908 27.547 16.0395 28.2407C15.6881 28.9343 15.5034 29.7004 15.5 30.478M22.5 23.16V24.786C22.5038 25.1286 22.5955 25.4645 22.7664 25.7615C22.9373 26.0585 23.1817 26.3066 23.476 26.482C24.1009 26.9448 24.6092 27.547 24.9605 28.2407C25.3119 28.9343 25.4966 29.7004 25.5 30.478M26.5 17.5H28C28.663 17.5 29.2989 17.2366 29.7678 16.7678C30.2366 16.2989 30.5 15.663 30.5 15C30.5 14.337 30.2366 13.7011 29.7678 13.2322C29.2989 12.7634 28.663 12.5 28 12.5H26.5M12.5 30.5H28.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 17.5C14.5 19.0913 15.1321 20.6174 16.2574 21.7426C17.3826 22.8679 18.9087 23.5 20.5 23.5C22.0913 23.5 23.6174 22.8679 24.7426 21.7426C25.8679 20.6174 26.5 19.0913 26.5 17.5V11.5C26.5 11.2348 26.3946 10.9804 26.2071 10.7929C26.0196 10.6054 25.7652 10.5 25.5 10.5H15.5C15.2348 10.5 14.9804 10.6054 14.7929 10.7929C14.6054 10.9804 14.5 11.2348 14.5 11.5V17.5ZM14.5 17.5H13C12.337 17.5 11.7011 17.2366 11.2322 16.7678C10.7634 16.2989 10.5 15.663 10.5 15C10.5 14.337 10.7634 13.7011 11.2322 13.2322C11.7011 12.7634 12.337 12.5 13 12.5H14.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRankingSelecionado);
export default __webpack_public_path__ + "static/media/iconRankingSelecionado.02133d953102b107d1b671594e595640.svg";
export { ForwardRef as ReactComponent };